module.exports = __webpack_public_path__ + "img/default-user-img.06befcc4.png";